/**
 * @typedef {Object} ClientFormData данные пользователя (Client) для формы бронирования/запроса
 * @property {string} name имя пользователя
 * @property {string} lastName фамилия
 * @property {string} patronymic отчество
 * @property {string} phoneNumber номер телефона
 * @property {string} email почта
 * @property {string} birthday дата рождения
 * @property {string} comment особые пожелания
 * @property {string} with_pet "путешествую с питомцем"
 * @property {string} petInfo дополнительная информация о питомце
 * @property {string} realArrival предполагаемое фремя прибытия
 */

export const ClientFormStorage = (() => {
  /** Название поля в localStorage, соответствующего данным пользователя (Client) для формы бронирования/запроса */
  const KEY = 'CLIENT_FORM_DATA_KEY';

  /** @type Partial<ClientFormData> */
  const clientFormData = load();

  function load() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '{}');
    } catch {
      return {};
    }
  }

  function save() {
    localStorage.setItem(KEY, JSON.stringify(clientFormData));
  }

  return {
    get(field) {
      return clientFormData[field];
    },
    set(field, value) {
      if (clientFormData[field] === value) return;

      clientFormData[field] = value;
      save();
    },
    clear() {
      for (const field of Object.keys(clientFormData)) {
        delete clientFormData[field];
      }
      save();
    },
  };
})();
